<template>
  <form-item-wrapper :designer="designer" :field="field" :rules="rules" :design-state="designState"
                     :parent-widget="parentWidget" :parent-list="parentList" :index-of-parent-list="indexOfParentList"
                     :sub-form-row-index="subFormRowIndex" :sub-form-col-index="subFormColIndex"
                     :sub-form-row-id="subFormRowId">
    <!--    <el-input ref="fieldEditor" v-model="fieldModel"-->
    <!--              :disabled="field.options.disabled" :readonly="field.options.readonly"-->
    <!--              :size="field.options.size" class="hide-spin-button"-->
    <!--              :type="inputType"-->
    <!--              :show-password="field.options.showPassword"-->
    <!--              :placeholder="field.options.placeholder"-->
    <!--              :clearable="field.options.clearable"-->
    <!--              :minlength="field.options.minLength" :maxlength="field.options.maxLength"-->
    <!--              :show-word-limit="field.options.showWordLimit"-->
    <!--              :prefix-icon="field.options.prefixIcon" :suffix-icon="field.options.suffixIcon"-->
    <!--              @focus="handleFocusCustomEvent" @blur="handleBlurCustomEvent" @input="handleInputCustomEvent"-->
    <!--              @change="handleChangeEvent">-->
    <!--      <el-button slot="append" v-if="field.options.appendButton"-->
    <!--                 :disabled="field.options.disabled || field.options.appendButtonDisabled"-->
    <!--                 :class="field.options.buttonIcon" @click.native="emitAppendButtonClick"></el-button>-->
    <!--    </el-input>-->
    <el-button v-if="!field.options.disabled" type="primary" style="margin-bottom: 10px;" icon="el-icon-plus"
               @click="addTarget">添加指标
    </el-button>
    <el-table
        :data="tableData"
        stripe
        border
        style="width: 100%;"
    >
      <el-table-column
          prop="name"
          label="单位"
          align="center"
          fixed="left"
          width="100">
      </el-table-column>
      <el-table-column
          v-for="(item,index) in fieldModel.target"
          :key="index"
          width="250"
          align="center"
      >
        <template slot="header" slot-scope="scope">
          <div class="inputs">
            <el-input placeholder="指标名" v-model="item.name" class="name" :disabled="field.options.disabled"></el-input>
            <!--            <el-input placeholder="单位：%" v-model="item.unit" :disabled="field.options.disabled"></el-input>-->
            <el-select
                v-model="item.unit"
                filterable
                allow-create
                default-first-option
                placeholder="请选择文章标签">
              <el-option
                  v-for="item in unitOptions"
                  :key="item.value"
                  :label="item.value"
                  :value="item.value">
              </el-option>
            </el-select>
            <div class="dele" v-if="Object.keys(fieldModel.target).length > 1 && !field.options.disabled">
              <!--              <el-button type="danger" size="mini" icon="el-icon-minus" circle></el-button>-->
              <i class="el-icon-minus" @click="deleteTarget(index)"></i>
            </div>

          </div>

        </template>
        <template slot-scope="scope">
          <div class="inputs" :style="{paddingRight:Object.keys(fieldModel.target).length > 1 ? '23px': ''}">
            <el-input placeholder="目标值" v-model="scope.row.target[index].target"
                      :disabled="field.options.disabled"></el-input>
            <el-input placeholder="完成值" v-model="scope.row.target[index].completion"></el-input>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </form-item-wrapper>
</template>

<script>
import FormItemWrapper from './form-item-wrapper'
import emitter from '@/utils/emitter'
import i18n from "@/utils/i18n";
import fieldMixin from "@/components/form-designer/form-widget/field-widget/fieldMixin";
import {compareArrays, deepClone, deepCompare} from "@/utils/util"

export default {
  name: "target-widget",
  componentName: 'FieldWidget',  //必须固定为FieldWidget，用于接收父级组件的broadcast事件
  mixins: [emitter, fieldMixin, i18n],
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,

    designState: {
      type: Boolean,
      default: false
    },

    subFormRowIndex: { /* 子表单组件行索引，从0开始计数 */
      type: Number,
      default: -1
    },
    subFormColIndex: { /* 子表单组件列索引，从0开始计数 */
      type: Number,
      default: -1
    },
    subFormRowId: { /* 子表单组件行Id，唯一id且不可变 */
      type: String,
      default: ''
    },

  },
  components: {
    FormItemWrapper,
  },
  inject: ['refList', 'formConfig', 'globalOptionData', 'globalModel'],
  data() {
    return {
      oldFieldValue: null, //field组件change之前的值
      fieldModel: {
        target: {
          1: {
            name: '',
            unit: '',
            target: '',
            completion: '',
          }
        }
      },
      rules: [],
      tableData: [
        {
          id: 0,
          name: '共计',
          target: {
            1: {
              targetId: '1',
              target: '',
              completion: '',
            }
          }
        }
      ],
      oldTableData: [],
      unitOptions: [
        {
          value: '%'
        },
        {
          value: '个'
        },
        {
          value: '元'
        },
        {
          value: '次'
        },
        {
          value: '辆'
        }
      ]
    }
  },
  computed: {
    inputType() {
      if (this.field.options.type === 'number') {
        return 'text'  //当input的type设置为number时，如果输入非数字字符，则v-model拿到的值为空字符串，无法实现输入校验！故屏蔽之！！
      }

      return this.field.options.type
    },
  },
  beforeCreate() {
    /* 这里不能访问方法和属性！！ */
  },
  watch: {

    tableData: {
      deep: true,
      handler(value) {
        // if(value.length > 1){
        //   console.log(value[0], value[1], deepCompare(value[0].target, value[1].target));
        //   if(!deepCompare(value[0].target, value[1].target)) {
        //     this.tableData[1].target = deepClone(value[0].target)
        //   }
        // }

        // if (compareArrays(value, this.oldTableData).length != 0 || this.oldTableData.length === 0) {
        //   this.oldTableData = deepClone((value));
        //   if (this.tableData.length > 1) {
        //     for (const targetKey in this.tableData[0].target) {
        //       let item = this.tableData[0].target[targetKey];
        //       let targetAll = 0;
        //       let completionAll = 0;
        //       this.tableData.slice(1).forEach(e => {
        //         targetAll += +(e.target[targetKey].target)
        //         completionAll += +(e.target[targetKey].completion)
        //       })
        //       if (targetAll != 0 && item.target != targetAll) {
        //         console.log(item.target, targetAll);
        //         item.target = targetAll;
        //       }
        //       if (completionAll != 0 && item.completion != completionAll) {
        //         item.completion = completionAll;
        //       }
        //     }
        //   }
        // }
        this.exportValue();
      }
    },
    fieldModel: {
      deep: true,
      handler(value) {
        let target = deepClone(value.target);
        if (Object.keys(target).length > 0) {
          for (const targetKey in target) {
            let item = target[targetKey];
            if (!this.tableData[0].target[targetKey]) {
              this.$set(this.tableData[0].target, targetKey, {})
            } else {
              break;
            }
            this.$set(this.tableData[0].target[targetKey], 'targetId', targetKey)
            this.$set(this.tableData[0].target[targetKey], 'target', item.target)
            this.$set(this.tableData[0].target[targetKey], 'completion', item.completion);
          }
        }
        let dutyUnit = deepClone(value.dutyUnit)
        console.log(dutyUnit);
        if (typeof dutyUnit === 'object' && Object.keys(dutyUnit).length > 0) {
          for (const valueKey in dutyUnit) {
            if (this.tableData.filter(e => e.id == valueKey).length > 0) {
              continue;
            } else {
              let item = dutyUnit[valueKey];
              let tableRow = {
                id: valueKey,
                name: '',
                target: {}
              }
              item.forEach(e => {
                tableRow.name = e.name
                tableRow.target[e.targetId] = {
                  targetId: e.targetId,
                  target: e.target,
                  completion: e.completion,
                }
              })

              this.tableData.push(tableRow)
            }

          }
        }
        this.exportValue();
      }
    },
    "field.options.dutyUnitList": {
      deep: true,
      handler(val) {
        if (!val) {
          return;
        }
        for (let i = 0; i < this.tableData.length; i++) {
          if (val?.findIndex(item => item.id == this.tableData[i].id) === -1 && this.tableData[i].id != 0) {
            this.tableData = this.tableData.filter((e, index) => i != index);
          }
        }
        for (let i = 0; i < val.length; i++) {
          if (this.tableData.findIndex(item => item.id == val[i].id) === -1) {
            let data = {}
            data.id = val[i].id;
            data.name = val[i].name;
            let target = {};
            for (const targetKey in this.fieldModel.target) {
              target[targetKey] = {
                targetId: targetKey,
                target: '',
                completion: ''
              }
            }
            data.target = target;
            this.tableData.push(data);
          }
        }
      }
    }
  },
  created() {
    /* 注意：子组件mounted在父组件created之后、父组件mounted之前触发，故子组件mounted需要用到的prop
       需要在父组件created中初始化！！ */
    this.initFieldModel()
    this.registerToRefList()
    this.initEventHandler()
    this.buildFieldRules()

    this.handleOnCreated()
  },

  mounted() {
    if (this.field.options.unitSource) {
      let unitRef = this.getWidgetRef(this.field.options.unitSource);
      unitRef.field.options.onChange += `setTimeout(() => {this.getWidgetRef("${this.field.options.name}").setWidgetOption("dutyUnitList", this.getValue().value.map((e, i)=> ({id: e, name: this.getValue().value_name[i]})))}, 0);`
      unitRef.field.options.onCreated += `setTimeout(() => {this.getWidgetRef("${this.field.options.name}").setWidgetOption("dutyUnitList", this.getValue().value.map((e, i)=> ({id: e, name: this.getValue().value_name[i]})));}, 0);`

    }
    this.handleOnMounted()
  },

  beforeDestroy() {
    if (this.field.options.unitSource) {
      let unitRef = this.getWidgetRef(this.field.options.unitSource);
      if (unitRef) {
        unitRef.field.options.onChange = ''
        unitRef.field.options.onCreated = ''
      }
    }
    this.unregisterFromRefList()
  },

  methods: {
    addTarget() {
      const index = +(Object.keys(this.fieldModel.target).slice(-1)) + 1;
      this.$set(this.fieldModel.target, index, {
        name: '',
        unit: '',
        target: '',
        completion: '',
      })
      this.addUnitTarget(index);
    },
    addUnitTarget(index) {
      for (let i = 0; i < this.tableData.length; i++) {
        this.$set(this.tableData[i].target, index, {
          targetId: index,
          target: '',
          completion: '',
        })
      }
    },
    deleteTarget(index) {
      this.$delete(this.fieldModel.target, index);
      this.deleteUnitTarget(index);
    },
    deleteUnitTarget(index) {
      for (let i = 0; i < this.tableData.length; i++) {
        this.$delete(this.tableData[i].target, index)
      }
    },
    exportValue() {
      let value = {
        target: {},
        dutyUnit: {}
      }
      let nowTarget = deepClone(this.fieldModel.target)
      for (const targetKey in nowTarget) {
        let data = nowTarget[targetKey];
        data.target = this.tableData[0].target[targetKey].target;
        data.completion = this.tableData[0].target[targetKey].completion;
        value.target[targetKey] = data;
      }
      this.$nextTick(() => {
        this.tableData.slice(1).forEach(item => {
          value.dutyUnit[item.id] = []
          for (const targetKey in item.target) {
            let e = item.target[targetKey];
            value.dutyUnit[item.id].push({
              ...e,
              name: item.name
            })
          }
        })
      })

      this.handleChangeEvent(value);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/global.scss"; //* form-item-wrapper已引入，还需要重复引入吗？ *//
.inputs {
  display: flex;
  box-sizing: border-box;

  .name {
    //flex-shrink: 0;
    //width: 115px;
  }

  .dele {
    display: flex;
    align-items: center;

    i {
      color: #fff;
      background-color: #F56C6C;
      width: 18px;
      height: 18px;
      line-height: 18px;
      border-radius: 50%;
      font-size: 12px;
      margin-left: 5px;
    }
  }
}
</style>
